import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV === "development";

const findError = (args) => args.find((arg) => arg instanceof Error);

export const logger = {
  debug: (...args) => {
    if (isDev) {
      console.debug(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
    if (!isDev) {
      const err = findError(args);
      if (err) {
        Sentry.captureException(err);
      }
    }
  },
};
